<script>
   /*********************************************************************/
   /* Contributions modal                                               */
   /* --------------------                                              */
   /* plot variables contributions to q/h distances for selected object */
   /*********************************************************************/

	import { fade } from 'svelte/transition';

   let {
      closeModal,
      children
   } = $props();

   function handleKeys(e) {
      if (e.key === 'Escape') closeModal();
   }
</script>
<svelte:window onkeydown={handleKeys}/>
<div class="drop" transition:fade|global >
   <!-- svelte-ignore a11y_no_static_element_interactions -->
   <div class="modal" >
      <div class="header">
         <button class="close-button" onclick={closeModal}>✕</button>
      </div>

      <div class="body" >
      {@render children()}
      </div>

   </div>
</div>

<style>
   .drop {
      position: fixed;
      z-index: 9999;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000000a0;
   }

   .modal {
      border-radius: 0.5rem;
      background-color: white;
      display: grid;
      grid-template-areas:
         "header"
         "body";
      grid-template-rows: 30px 1fr;
      width: auto;
      height: auto;

      width: auto;
      height: auto;
      border-radius: .25rem;
   }

   .body {
      grid-area: body;
      box-sizing: border-box;
      padding: 0 1em 0.5em 1em;
      width: 100%;
      height: 100%;
   }

   .header {
      grid-area: header;
   }

   .close-button {
      cursor: pointer;
      border: none;
      box-shadow: none;
      background: transparent;
      font-size: inherit;
      font-weight: bold;
      color: #f8ebc5;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background-color: #9ea0a2;
      float: right;
      text-align: center;
      padding: 0;
      line-height: 20px;
      font-size: 12px;
      margin: 5px;
   }

   .close-button:hover {
      background-color: #4e5052;
   }
</style>